<template>
  <div class="popup-wraper" @click="onHideModal">
    <div class="popup-overlay aep" @click.stop>
      <div class="popup-overlay-title aep">
        <img alt="img" src="@/assets/img/publish_as_community.svg" />
        <span class="popup-overlay-title-span">
          contribute {{ catalogTab }}
        </span>
      </div>
      <div class="popup-scroll aep" ref="dropZone">
        <preloader class="popup-preloader" :visible="showPreloader" />
        <div class="add-tag-contanier" v-if="catalogTab === 'categories'">
          <!-- status -->
          <div class="aep-select-field" v-if="isEditor">
            <el-dropdown trigger="click">
              <div class="aep-filter-select">
                <div class="aep-select-container">
                  {{ item.status }}
                  <img
                    alt="img"
                    src="@/assets/img/select_arrow.svg"
                    class="p-arrow"
                  />
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="aep-aep-select-list">
                  <div
                    class="aep-select-item"
                    v-for="(p, idx) of ['on review', 'validated', 'rejected']"
                    :key="idx"
                    @click="item.status = p"
                  >
                    {{ p }}
                  </div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="aep-field-name ">status</div>
          </div>
          <!-- name -->
          <label class="manager-label">
            <input
              type="text"
              v-focus
              class="input aep manager-input"
              v-model="item.name"
            />
            <div class="aep-field-name">name</div>
          </label>
          <!-- position -->
          <label v-if="isEditor">
            <input
              class="aep-search-input"
              type="number"
              disabled
              v-model.number="item.position"
            />
            <div class="aep-field-name ">position</div>
          </label>
          <textarea
            v-if="!isEditor"
            class="aep-comment-text"
            v-model="itemComment"
          ></textarea>
        </div>
        <!-- interactions -->
        <div class="add-tag-contanier" v-if="catalogTab === 'interactions'">
          <draggable class="step-items aep" v-model="item.pages">
            <div v-for="(s, idx) in item.pages" :key="idx" class="step-item">
              <img alt="img" v-if="s && s.img" :src="s.img" />
            </div>
          </draggable>
          <!-- position -->
          <label>
            <input
              class="aep-search-input"
              type="number"
              disabled
              v-model.number="item.position"
            />
            <div class="aep-field-name ">position</div>
          </label>
          <!-- name -->
          <label class="manager-label">
            <input
              type="text"
              class="input aep manager-input"
              v-model="item.name"
            />
            <div class="aep-field-name ">name</div>
          </label>
        </div>
        <!-- templates / images / texts -->
        <div
          class="aep-add-element"
          v-if="
            catalogTab === 'templates' ||
              catalogTab === 'texts' ||
              catalogTab === 'images'
          "
        >
          <div v-show="catalogTab === 'images'" class="aep-size">
            {{ getSizeInMBs(item.size) }}
          </div>

          <div class="drop-effect"></div>
          <!-- review -->
          <div
            v-if="catalogTab.match(/(templates|texts)/)"
            class="aep-image-container"
          >
            <img alt="img" class="aep-review-img" :src="item.img" />
          </div>
          <label v-else>
            <input
              type="file"
              @change="onUploadImage"
              accept="image/svg+xml"
              hidden
            />
            <div
              class="aep-image-container"
              :class="{ 'aep-upload-container': !item.img }"
            >
              <img
                alt="img"
                class="aep-review-img"
                :src="item.img || require('@/assets/img/upload.svg')"
              />
            </div>
            <div class="aep-field-name">upload</div>
          </label>
          <!-- size -->
          <div
            v-if="catalogTab.match(/(templates|texts)/)"
            class="aep-field-name"
          >
            {{ getSizeInMBs(item.size) }}
          </div>
          <!-- name -->
          <label class="manager-label">
            <input
              type="text"
              class="input aep manager-input"
              v-model="item.name"
            />
            <div class="aep-field-name">name</div>
          </label>
          <!-- copyright -->
          <label class="manager-label" v-if="catalogTab === 'images'">
            <input
                type="text"
                class="input aep manager-input"
                v-model="item.copyright"
            />
            <div class="aep-field-name ">copyright</div>
          </label>
          <!-- categories -->
          <div class="aep-select-field">
            <div class="aep-filter-select" style="max-width: 460px;">
              <el-dropdown trigger="click">
                <div class="aep-select-container">
                  <div class="aep-select-text">
                    {{ getCtgs(item.categories) }}
                  </div>
                  <img
                    alt="img"
                    src="@/assets/img/select_arrow.svg"
                    class="p-arrow"
                  />
                </div>
                <el-dropdown-menu
                  class="categories-dropdown-menu"
                  slot="dropdown"
                >
                  <input
                    type="text"
                    class="aep-search-input"
                    v-model="ctgsFilterInput"
                    @click.stop
                  />
                  <div class="aep-aep-select-list">
                    <label
                      class="checkbox-container filters"
                      v-for="(c, idx) of categoriesListMod"
                      :key="idx"
                    >
                      <input
                        type="checkbox"
                        hidden
                        @change="updateCtgList(item.categories, c)"
                        :checked="isCheckedCategory(item.categories, c)"
                      />
                      <div class="checkbox-item"></div>
                      <span>{{ c.name }}</span>
                    </label>
                    <div @click.stop="goToAddCategory" class="aep-new-category">
                      <img
                        alt="img"
                        class="aep-new-category-img"
                        src="@/assets/img/add_btn.svg"
                      />
                      <span>contribute a new category</span>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="aep-field-name">categories</div>
          </div>
          <!-- status -->
          <div class="aep-select-field" v-if="isEditor">
            <el-dropdown trigger="click">
              <div class="aep-filter-select">
                <div class="aep-select-container">
                  {{ item.status }}
                  <img
                    alt="img"
                    src="@/assets/img/select_arrow.svg"
                    class="p-arrow"
                  />
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="aep-aep-select-list">
                  <div
                    class="aep-select-item"
                    v-for="(p, idx) of ['on review', 'validated', 'rejected']"
                    :key="idx"
                    @click="item.status = p"
                  >
                    {{ p }}
                  </div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="aep-field-name ">status</div>
          </div>
          <textarea
            v-if="!isEditor"
            class="aep-comment-text"
            v-model="itemComment"
          ></textarea>
          <div v-if="!isEditor">
            <span class="span-text">comment (optional)</span>
          </div>
        </div>
        <!-- fonts -->
        <div class="aep-add-element" v-else-if="catalogTab === 'fonts'">
          <!-- size -->
          <div class="aep-size">
            {{ getSizeInMBs(item.size) }}
          </div>
          <!-- review -->
          <label>
            <div
              class="aep-image-container"
              :class="{ 'aep-upload-container': !item.fontFamily }"
            >
              <div
                v-if="item.content"
                class="aep-font-review"
                :style="{ 'font-family': item.fontFamily }"
              >
                {{ item.name || "POSTER I LOVE" }}
              </div>
              <img
                alt="img"
                v-else
                class="aep-review-img"
                style="border-radius: 0;"
                src="@/assets/img/upload.svg"
              />
              <input type="file" @change="onUploadFont" hidden />
            </div>
            <div class="aep-field-name">upload</div>
          </label>

          <!-- status -->
          <div class="aep-select-field" v-if="isEditor">
            <el-dropdown trigger="click">
              <div class="aep-filter-select">
                <div class="aep-select-container">
                  {{ item.status }}
                  <img
                    alt="img"
                    src="@/assets/img/select_arrow.svg"
                    class="p-arrow"
                  />
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="aep-aep-select-list">
                  <div
                    class="aep-select-item"
                    v-for="(p, idx) of ['on review', 'validated', 'rejected']"
                    :key="idx"
                    @click="item.status = p"
                  >
                    {{ p }}
                  </div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="aep-field-name ">status</div>
          </div>
          <!-- name -->
          <label class="manager-label">
            <input
              type="text"
              class="input aep manager-input"
              v-model="item.name"
            />
            <div class="aep-field-name ">name</div>
          </label>
          <!-- copyright -->
          <label class="manager-label">
            <input
              type="text"
              class="input aep manager-input"
              v-model="item.copyright"
            />
            <div class="aep-field-name ">copyright</div>
          </label>
          <textarea
            v-if="!isEditor"
            class="aep-comment-text"
            v-model="itemComment"
          ></textarea>
        </div>
      </div>
      <label v-if="!isEditor" class="checkbox-container aep">
        <input type="checkbox" v-model="isAcceptedItem" hidden />
        <div class="checkbox-item" style="margin-right: 8px;"></div>
        <span class="aep-field-name" style="margin: 0;"
          >I accept terms and conditions</span
        >
      </label>
      <button
        class="popup-btn"
        :data-is-avalable="popupsVisible"
        id="apply-btn"
        ref="addBtn"
        @click="onSubmit"
      >
        <div v-show="errorMsg" class="error aep">{{ errorMsg }}</div>
        {{ isEditor ? "apply" : "send for review" }}
      </button>
      <div class="popup-close" @click="onHideModal">&times;</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// services
import { fetchLocalFont, getFontPreview } from "@/helpers/fontsHelper";
import LogsService from "@/services/LogsService";
import preloader from "@/components/preloaderMenu";
import resizeCanvasForText from "@/util/canvas/resizeCanvasForText";
import draggable from "vuedraggable";
import contributionsMixin from "@/mixins/contributions";
// ? styles
import "@/assets/css/popups.css";
import "@/assets/css/addEditPopups.css";
import {svgToPng} from "@/util/imageConvertor";

export default {
  name: "addPopup",
  mixins: [contributionsMixin],
  components: {
    preloader,
    draggable
  },
  data() {
    return {
      errorMsg: "",
      ctgsFilterInput: "",
      interactionsFilterInput: "",
      backToTabAfterAddNewCategory: "",
      categoriesList: [],
      review: null,
      // templates / richImages / texts
      isAcceptedItem: false,
      showPreloader: true,
      itemComment: "",
      item: {},
      itemMocks: {
        templates: {
          comment: [],
          img: "",
          content: "",
          name: "",
          size: 0,
          categories: [],
          status: "validated"
        },
        images: {
          comment: [],
          img: null,
          content: null,
          name: "",
          size: 0,
          categories: [],
          status: "validated"
        },
        fonts: {
          comment: [],
          content: null,
          name: "",
          size: 0,
          copyright: "",
          status: "validated",
          preview: "",
          fontFamily: null
        },
        categories: {
          comment: [],
          position: 0,
          status: "validated"
        },
        interactions: {
          position: 0,
          name: "",
          pages: []
        },
        texts: {
          comment: [],
          content: "",
          img: "",
          name: "",
          size: 0,
          categories: [],
          status: "validated"
        },
        pages: {
          img: "",
          content: null,
          name: "",
          size: 0,
          favicon: "",
          visibility: true,
          interaction: null
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      canvas: "workSpace/canvas",
      allCategories: "contributions/allCategories",
      allInteractions: "contributions/allInteractions",
      popupsVisible: "workSpace/popupsVisible",
      popupsData: "workSpace/popupsData",
      survey: "workSpace/survey",
      activeMyInteraction: "workSpace/activeMyInteraction"
    }),
    catalogTab() {
      return this.popupsData.step;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      try {
        // ? back to add popup with existing content
        if (this.popupsData.item) this.item = this.popupsData.item;
        // ? new item
        else {
          this.item = JSON.parse(
            JSON.stringify(this.itemMocks[this.catalogTab])
          );
          this.getCanvasData();
        }
      } catch (error) {
        console.log(error);
        this.onHideModal();
      }
      this.$store
        .dispatch("contributions/getAllCategoriesAndInteractions")
        .then(() => {
          if (this.catalogTab === "categories")
            this.item.position =
              Math.max(...this.allCategories.map(c => c.position)) + 1;
          if (this.catalogTab === "interactions")
            this.item.position =
              Math.max(...this.allInteractions.map(s => s.position)) + 1;
        });
    },
    async onSubmit() {
      try {
        this.$refs.addBtn.disabled = true;
        const _addFuncName =
          this.catalogTab.slice(0, 1).toUpperCase() + this.catalogTab.slice(1);
        if (!this.isEditor && this.item.status) {
          this.item.status = "on review";
        }
        const resilt = await this[`add${_addFuncName}`]();
        if (resilt?.error) throw Error(resilt?.error?.message);
        LogsService.createLog({
          action: "creation contribution",
          data: {
            type: this.catalogTab
              .slice(0, -1)
              .replace("image", "rich image")
              .replace("categories", "category")
          }
        });
        this.$refs.addBtn.disabled = false;
        this.onHideModal();
      } catch (error) {
        console.log(error);
        this.errorMsg = error.message;
        this.$refs.addBtn.disabled = false;
      }
    },
    async addCategories() {
      // ? validation
      if (!this.item.name) throw Error("please input name");
      if (!this.isEditor && !this.isAcceptedItem)
        throw Error("please accept terms and conditions");
      this.addComment();
      const newCategory = await this.$store.dispatch(
        "contributions/addContentItem",
        {
          newItem: this.item,
          type: "categories"
        }
      );
      // ? add category to editing item
      if (this.popupsData?.addData)
        this.popupsData?.addData?.item?.categories?.push(newCategory);
      if (this.popupsData?.editData)
        this.popupsData?.editData?.item?.categories?.push(newCategory);
    },
    async addInteractions() {
      // ? validation
      if (!this.item.name) throw Error("please input name");

      const interaction = await this.$store.dispatch(
        "contributions/addContentItem",
        {
          newItem: this.item,
          type: "interactions"
        }
      );
      const promises = [];
      for (let i = 0; i < this.item.pages.length; i++) {
        const page = {
          interaction_id: interaction.id,
          name: interaction.name + (i + 1),
          interaction_position: i + 1,
          visibility: true,
          ...this.item.pages[i]
        };
        promises.push(this.addPages(page));
      }
      await Promise.all(promises);
    },
    async addPages(item) {
      // ? validation
      // if (!this.item.name) throw Error("please input name");
      return this.$store.dispatch("contributions/addContentItem", {
        newItem: item,
        type: "pages"
      });
    },

    async addImages() {
      // ? validation
      if (!this.item.name) throw Error("please input name");
      else if (!this.item.content) throw Error("please add image");
      else if (!this.isEditor && !this.isAcceptedItem)
        throw Error("please accept terms and conditions");
      this.addComment();
      return this.$store.dispatch("contributions/addContentItem", {
        newItem: this.item,
        type: "richImages"
      });
    },
    async addTemplates() {
      // ? validation
      if (!this.item.categories.length && !this.isEditor)
        throw Error("select at least one category");
      else if (!this.item.name) throw Error("please input name");
      if (!this.isEditor && !this.isAcceptedItem)
        throw Error("please accept terms and conditions");
      this.addComment();
      return this.$store.dispatch("contributions/addContentItem", {
        newItem: this.item,
        type: "templates"
      });
    },
    async addTexts() {
      // ? validation
      if (!this.item.categories.length && !this.isEditor)
        throw Error("select at least one category");
      else if (!this.item.name) throw Error("please input name");
      if (!this.isEditor && !this.isAcceptedItem)
        throw Error("please accept terms and conditions");
      this.addComment();

      return this.$store.dispatch("contributions/addContentItem", {
        newItem: this.item,
        type: "texts"
      });
    },
    async addFonts() {
      if (!this.item.content) throw Error("please add font");
      if (!this.item.name) throw Error("please input name");
      if (!this.isEditor && !this.isAcceptedItem)
        throw Error("please accept terms and conditions");
      this.addComment();
      this.item.preview = getFontPreview(this.item);
      return this.$store.dispatch("contributions/addContentItem", {
        newItem: this.item,
        type: "fonts"
      });
    },
    onHideModal() {
      if (this.popupsData?.editData) {
        this.$store.dispatch("workSpace/showPopup", {
          type: "editPopup",
          data: this.popupsData.editData
        });
        return;
      }
      if (this.popupsData?.addData) {
        this.$store.dispatch("workSpace/showPopup", {
          type: "addPopup",
          data: this.popupsData.addData
        });
        this.init();
        return;
      }
      this.$emit("hide-modal");
    },
    showError(msg = "") {
      this.errorMsg = msg;
    },
    async goToAddCategory() {
      this.backToTabAfterAddNewCategory = this.catalogTab;
      await this.$store.dispatch("workSpace/showPopup", {
        type: "addPopup",
        data: {
          step: "categories",
          // ? data back to edit popups after adding category
          addData: {
            step: this.catalogTab,
            item: JSON.parse(JSON.stringify(this.item))
          }
        }
      });
      this.init();
    },
    addComment() {
      if (this.itemComment) {
        this.item.comment.push({
          date: new Date().toISOString(),
          msg: this.itemComment,
          user_email: this.currentUser?.email
        });
      }
    },
    isCheckedCategory(categoriesList, category) {
      return (
        categoriesList &&
        categoriesList.findIndex(c => category.id === c.id) > -1
      );
    },
    async onUploadImage(e) {
      const file = e.target?.files?.[0] ?? e;
      this.item.img = await svgToPng(file);
      this.item.content = file;
      this.item.size = file.size;
    },
    async onUploadFont(e) {
      this.showError();
      try {
        const file = e.target?.files?.[0] ?? e;
        const name = file.name.replace(/\.(t|o)tf/g, "");
        await fetchLocalFont(file, name);
        this.item.content = file;
        this.item.size = file.size;
        this.item.name = this.item.fontFamily = name;
      } catch (error) {
        console.log(error);
        this.showError("supported only .otf and .ttf formats");
      }
    },
    getCtgs(ctgsList) {
      if (!ctgsList) return;
      return ctgsList.map(c => c.name).join(", ");
    },
    updateCtgList(itemsList, newCategory) {
      const index = itemsList.findIndex(c => c.id === newCategory.id);
      if (index === -1) itemsList.push(newCategory);
      else itemsList.splice(index, 1);
    },
    async getCanvasData() {
      let oldCanvasSizes = null;
      if (this.catalogTab === "texts")
        oldCanvasSizes = resizeCanvasForText(this.canvas);
      if (this.catalogTab === "templates" || this.catalogTab === "texts") {
        const { newContent, newImage, size } = await this.$store.dispatch(
          "workSpace/getCurrentCanvasData"
        );
        this.item.content = newContent;
        this.item.img = newImage;
        this.item.size = size;
      } else if (this.catalogTab === "interactions") {
        this.item.favicon = this.activeMyInteraction.favicon;
        this.item.pages = this.activeMyInteraction.parsedContent.map(
          (i, idx) => ({
            img: this.activeMyInteraction.img[idx],
            content: i
          })
        );
      }
      this.showPreloader = false;
      if (this.catalogTab === "texts")
        this.$store.commit("workSpace/updateCanvasSizes", {
          width: oldCanvasSizes?.width,
          height: oldCanvasSizes?.height
        });
    }
  }
};
</script>

<style scoped>
.manager-input {
  width: 200px;
}
.accept-checker-label {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.span-text {
  color: #4d4f5c;
  font-size: 10px;
}
</style>
